import { Box, Button, DialogFooter } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { Pagination } from 'shared/domains/common-ui';
import { CreateFolderPopover } from '../CreateFolderPopover';
import { SelectedEntries } from '../FileDialog/SelectedEntries';
export function PickerFooter(props) {
    const { submitLabel, showPagination, multiselect = false, showCreateFolder = false, disabled = false, onSubmit, } = props;
    const { loading, limit, offset, setOffset, count, fileBrowserSearch } = useFileBrowserContext();
    const { searching } = fileBrowserSearch;
    const submitDisabled = loading || disabled;
    return (<DialogFooter description={!searching && (<Box alignItems="center" gap="sm">
            {showCreateFolder && <CreateFolderPopover />}
            {showPagination && (<Pagination count={count} maxCount={10000} limit={limit} offset={offset} setOffset={setOffset} disabled={loading}/>)}
          </Box>)}>
      {multiselect && <SelectedEntries />}
      <Button size="small" appearance="primary" disabled={submitDisabled} onClick={onSubmit}>
        {submitLabel}
      </Button>
    </DialogFooter>);
}
